export const DE = {}
